import { useNavigate } from "react-router-dom";

import { useRandomSigninBackgroundImage } from "@/Helpers/randomBackgroundImage";
import { AuthenticationRequestReset } from "./CustomComponents/AuthenticationRequestReset";
import { AuthenticationScreenContainer } from "./CustomComponents/AuthenticationScreenContainer";

function RequestResetPasswordScreen() {
  const navigate = useNavigate();
  const backgroundImage = useRandomSigninBackgroundImage();

  return (
    <AuthenticationScreenContainer imageUrl={backgroundImage}>
      <AuthenticationRequestReset onBackToSignIn={() => navigate("/sign-in")} />
    </AuthenticationScreenContainer>
  );
}
export default RequestResetPasswordScreen;
